export const formTypesList = [
  'c:106',
  'c:201',
  'c:205a',
  'c:361',
  'c:362',
  'c:370',
  'c:410',
  'c:484',
  'c:6010',
  'c:492',
  'c:902'
];

export const excludedDocumentTypes = [
  "imported",
  "Imported",
  "IMPORTED"
];
